<div class="ag-filter-wrapper ag-focus-managed">
  <div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
    <div class="filter-container">
      <mat-checkbox *ngFor="let operation of selectableOptions" class="filter-item"
         (change)="toggleOption(operation)" [checked]="operation.selected">
        <mydocma-custom-mat-icon [iconName]="operation.icon" class="filter-icon">
        </mydocma-custom-mat-icon>
      </mat-checkbox>
    </div>
  </div>
</div>